import React from 'react';
import Carousel from 'react-elastic-carousel';
import Item from '../components/subcomponents/CarouselCookiesItem';
import cookieLeft from '../img/png/cookie_background_left.png';
import cookieRight from '../img/png/cookie_background_right.png';
import mvp from '../img/png/carousel_mvp.png';
import cookies from '../img/png/carousel_cookies.png';
import security from '../img/png/carousel_security.png';

function CarouselCookies() {
  //asdasds
  const breakPoints = [{ width: 1, itemsToShow: 1 }];

  const carousel = [
    {
      image: mvp,
      title: 'Most Valuable Product 2021',
      subtitle:
        'Data shows that campaigns under ONE Market consistently outperform cookie-based campaigns by at least 20% (TECH MVPs)',
      link: 'https://www.campaignasia.com/article/tech-mvp-2021-sqreem-one-market/469770',
    },
    {
      image: cookies,
      title: 'We don’t use third-party cookies',
      subtitle: 'ONE Market is ready for a cookieless future.',
      link: 'https://www.thedrum.com/opinion/2021/04/29/google-s-floc-has-flown-what-now-apac',
    },
    {
      image: security,
      title: 'GDPR Compliant',
      subtitle: 'ONE Market is 100% compliant with EU’s toughest privacy laws.',
      link: 'https://www.thedrum.com/opinion/2021/04/29/google-s-floc-has-flown-what-now-apac',
    },
  ];

  return (
    <section className='carousel'>
      <div className='carousel_container'>
        <div className='carousel-wrapper'>
          <Carousel breakPoints={breakPoints}>
            {carousel.map((item, index) => {
              return (
                <Item
                  key={index}
                  image={item.image}
                  title={item.title}
                  subtitle={item.subtitle}
                  link={item.link}
                ></Item>
              );
            })}
          </Carousel>
        </div>
      </div>
      <div className='carousel_background'>
        <div className='carousel_background d-flex justify-content-between'>
          <div className='carousel_background_left d-flex align-items-end'>
            <img src={cookieLeft} alt='background' />
          </div>
          <div className='carousel_background_right d-flex align-items-center'>
            <img src={cookieRight} alt='background' />
          </div>
        </div>
      </div>
    </section>
  );
}

export default CarouselCookies;
